export  function popupLanguages() {

    let userLanguage = function() { 
        let baseLang = (navigator.language || navigator.userLanguage).substring(0,2).toLowerCase();

        if (typeof languages !== 'undefined' && languages.hasOwnProperty(baseLang)) {
            let currentLanguage = languages[baseLang];
            let popup = $('<div class="popup-block languages-popup active"><div class="popup-block-inner"><div class="popup-block-content"><div class="close"><svg  class="icon-close stroke" viewBox="0 0 28 28" fill="none"><path d="M26 26L2 2M26 2L2 26" stroke-width="3"/></svg></div><div class="text-block popup-content custom-scrollbar"><h3 class="h3">'+ currentLanguage.title +'</h3><p>'+ currentLanguage.text +'</p><a href="'+currentLanguage.link.url+'" target="'+currentLanguage.link.target+'" class="button white"><span class="language-text">'+ currentLanguage.link.title +'</span></a></div></div></div></div>');
            $('body').addClass('scroll-lock');
            $(".wrapper").append(popup);
        }
    };

    $(document).on('click', function(e) {
        if($(e.target).closest('.languages-popup').length) {
            if($(e.target).hasClass("close") || $(e.target).closest('.popup-block-content').length == 0){
                $('body').removeClass('scroll-lock');
                $(".languages-popup").removeClass('active');
            }
        }
    });

    if (!localStorage.getItem('languageShow')) {
        localStorage.setItem('languageShow', true);
        userLanguage();
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/popupLanguages.js